<template>
	<div class="mmm">
  <!--<header>
    <h1>
      <span  v-on:click="replyx()">
        <v-icon name="chevron-left" class="set_2"></v-icon>
      </span>
    </h1>
  </header>-->
		<p class="ppp_1">{{book_gc.bp_bookname}}&nbsp;&nbsp;{{book_gc.bp_title}}</p>
		<div class="mp3">
			<button class="maaj" v-on:click="maaj()">A-</button>
			<button class="maax" v-on:click="maax()">A+</button>
			<div class="ppp_2" v-html="book_gc.bp_content">
				<p>{{book_gc.bp_content}}</p>
			</div>
			<img :src="'http://ts.winwulian.com/uploads/booklistphoto/'+b_pic" class="bg_pic" />
            <div class="yy">
                <!-- <audio ref="player" preload="auto" autobuffer="autobuffer" :src="'http://ts.winwulian.com/upload/'+book_gc.bp_upload" id="audio_a"></audio> -->
            </div>	

		</div>
		<div class="mppp">
			<!-- 章节 -->
			<div class="barsx" v-on:click="section()" id="ka">
				<v-icon name="bars" class="cxxxx" id="barsc"></v-icon>
				<p>章节</p>
			</div>
			<!-- 收藏 -->
			<div class="heartx" v-on:click="heart()" id="ka">
				<v-icon name="heart" class="cxxxx" id="heartc"></v-icon>
				<p>收藏</p>
			</div>
			<!-- 定时 -->
			<div class="clockx" v-on:click="timing()" id="ka">
				<v-icon name="clock" class="cxxxx" id="clockc"></v-icon>
				<p>定时</p>
			</div>
			<!-- 专辑 -->
			<div class="replyx" v-on:click="replyx()" id="ka">
				<v-icon name="reply" class="cxxxx"></v-icon>
				<p>专辑</p>
			</div>
			<!-- <div id="adzc"><span id="xmint"></span></div>
			<div id="adocx">
				<div id="axcz"></div>
			</div>
			<div id="adzx"><span id="zmint"></span></div> -->

            <div class="di main-wrap" id="ys">
            <!-- 这里设置了ref属性后，在vue组件中，就可以用this.$refs.audio来访问该dom元素 -->
            <audio ref="audio" class="dn" 
            preload="preload"
            autoplay="autoplay"
            :src="'http://ts.winwulian.com/upload/'+book_gc.bp_upload" :preload="audio.preload"
            @play="onPlay" 
            @error="onError"
            @waiting="onWaiting"
            @pause="onPause" 
            @timeupdate="onTimeupdate" 
            @loadedmetadata="onLoadedmetadata"
            ></audio>
            <div>
              <el-tag type="info">{{ audio.currentTime | formatSecond}}</el-tag>
             <el-slider v-show="!controlList.noProcess" v-model="sliderTime" :format-tooltip="formatProcessToolTip" @change="changeCurrentTime" class="slider"></el-slider><!-- 进度条 -->
              <el-tag type="info">{{ audio.maxTime | formatSecond }}</el-tag>   
            </div>
              <el-button type="text" @click="startPlayOrPause" class="sxcaq">{{audio.playing | transPlayPause}}</el-button>
              <div class="fast-backward" id="righ" v-on:click="backward()">
                    <v-icon name="fast-backward"></v-icon>
                </div>
                <div class="fast-forward" id="rig" v-on:click="forwardc()">
                    <v-icon name="fast-forward"></v-icon>
                </div>
          </div>

			
		</div>
		<div class="zzcc">
			<div class="mzzz">
				<div class="mzzzd">
					<p class="mzz_p">章节</p>
					<button class="mzz_f" v-on:click="close()">x</button>
					<button class="mzz_x" v-on:click="loop()">查看下页</button>
					<button class="mzz_h" v-on:click="back()">返回专辑</button>
				</div>
				<div class="mzzzv">
					<!-- <p v-for="item in alebook" v-on:click="chapter(item.bp_id)">{{item.bp_title}}</p> -->
				</div>
			</div>
		</div>
		<div class="ddss">
			<div class="mzzz">
				<div class="mdxxzz">
					<p class="mzz_pxx">定时播放</p>
					<button class="mzz_ffff" v-on:click="shut()">x</button>
				</div>
				<div class="ddss_x">
					<div class="bkq0" v-on:click="noopen()">
						<p id="q0">不开启</p>
						<p id="q1" class="qq1">√</p>
					</div>
					<div class="bkq1" v-on:click="nopen()">
						<p id="q0">播放当前章节</p>
						<p id="q1" class="qq2"></p>
					</div>
					<!-- <div class="bkq2" v-on:click="allopen()">
						<p id="q0">播放全部章节</p>
						<p id="q1" class="qq3"></p>
					</div> -->
					<div class="bkq3" v-on:click="minopen()">
						<p id="q0">30分钟</p>
						<p id="q1" class="qq4"></p>
					</div>
					<div class="bkq4" v-on:click="hortopen()">
						<p id="q0">60分钟</p>
						<p id="q1" class="qq5"></p>
					</div>
				</div>
			</div>
		</div>
		<div class="tc_nav">
			<span class="tc_navx"></span>
		</div>
	</div>
</template>
<script>
import $ from 'jquery';
import { CURL } from "../../lib/url.js";
function realFormatSecond(second) {
    var secondType = typeof second
    if (secondType === 'number' || secondType === 'string') {
        second = parseInt(second)
        var hours = Math.floor(second / 3600)
        second = second - hours * 3600
        var mimute = Math.floor(second / 60)
        second = second - mimute * 60
        return hours + ':' + ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
    } else {
        return '0:00:00'
    }
}
export default {
props: {
    theSpeeds: {
        type: Array,
        default () {
            return [1, 1.5, 2]
        }
    },
    theControlList: {
        type: String,
        default: ''
    }
},
inject:['reload'],
data(){
    return {
        params: '',
        book_gc:[],
        j:13,//章节
        size:12,
        bookid:[],
        cbook:[], //总章节
        b_pic:'',
        ix:0, //却换章节
        listik:[], //却换章节下标存值response.bookpartlist[j].bp_id
        xheart:0,
        mtime:[],// 总时间
        dtime:[],//下一章时间
        stime:[],//上一章时间
        keyer:'',
        url: this.theUrl || '',
        audio: {
            currentTime: 0,
            maxTime: 0,
            playing: false,
            muted: false,
            speed: 1,
            waiting: true,
            preload: 'auto'
        },
        sliderTime: 0,
        volume: 100,
        speeds: this.theSpeeds,
        controlList: {
            // 不显示下载
            noDownload: true,
            // 不显示静音
            noMuted: true,
            // 不显示音量条
            noVolume: true,
            // 不显示进度条
            noProcess: false,
            // 只能播放一个
            onlyOnePlaying: false,
            // 不要快进按钮
            noSpeed: true
        }//定时
    }
},
filters: {
    formatSecond(second = 0) {
        return realFormatSecond(second)
    },
    transPlayPause(value) {
        return value ? '〓' : '▲'
    },
    transMutedOrNot(value) {
        return value ? '放音' : '静音'
    },
    transSpeed(value) {
        return '快进: x' + value
    }
},
created(){
    this.setControlList()
    var param = this.$route.params.id;
    this.params = param
    this.bookid = this.params.split(',')
},
// computed:{
// book_gc:function(){
// return this.book_gc.bp_content.slice(9,11);  
// }
// },
methods:{
    setControlList () {
        let controlList = this.theControlList.split(' ')
        controlList.forEach((item) => {
          if(this.controlList[item] !== undefined){
            this.controlList[item] = true
          }
        })
    },
    changeSpeed() {
        let index = this.speeds.indexOf(this.audio.speed) + 1
        this.audio.speed = this.speeds[index % this.speeds.length]
        this.$refs.audio.playbackRate = this.audio.speed
    },
    startMutedOrNot() {
        this.$refs.audio.muted = !this.$refs.audio.muted
        this.audio.muted = this.$refs.audio.muted
    },
    // 音量条toolTip
    formatVolumeToolTip(index) {
        return '音量条: ' + index
    },
    // 进度条toolTip
    formatProcessToolTip(index = 0) {
        index = parseInt(this.audio.maxTime / 100 * index)
        return '进度条: ' + realFormatSecond(index)
    },
    // 音量改变
    changeVolume(index = 0) {
        this.$refs.audio.volume = index / 100
        this.volume = index
    },
    // 播放跳转
    changeCurrentTime(index) {
        this.$refs.audio.currentTime = parseInt(index / 100 * this.audio.maxTime)
    },
    startPlayOrPause() {
        return this.audio.playing ? this.pausePlay() : this.startPlay()
    },
    // 开始播放
    startPlay() {
        this.$refs.audio.play()
    },
    // 暂停
    pausePlay() {
        this.$refs.audio.pause()
    },
    // 当音频暂停
    onPause () {
        this.audio.playing = false
    },
    // 当发生错误, 就出现loading状态
    onError () {
        this.audio.waiting = true
    },
    // 当音频开始等待
    onWaiting (res) {
        console.log(res)
    },
    // 当音频开始播放
    onPlay (res) {
        this.audio.playing = true
        this.audio.loading = false

        if(!this.controlList.onlyOnePlaying){
          return 
        }

        let target = res.target

        let audios = document.getElementsByTagName('audio');

        [...audios].forEach((item) => {
          if(item !== target){
            item.pause()
          }
        })
    },
    // 当timeupdate事件大概每秒一次，用来更新音频流的当前播放时间
    onTimeupdate(res) {
        this.audio.currentTime = res.target.currentTime
        this.sliderTime = parseInt(this.audio.currentTime / this.audio.maxTime * 100)
    },
    // 当加载语音流元数据完成后，会触发该事件的回调函数
    // 语音元数据主要是语音的长度之类的数据
    onLoadedmetadata(res) {
        this.audio.waiting = false
        this.audio.maxTime = parseInt(res.target.duration)
    },
   	//60分钟
   	hortopen:function(){
   		$('.qq5').text('√')
		$('.qq2').text('')
		$('.qq3').text('')
		$('.qq4').text('')
		$('.qq1').text('')
        $('.ddss').fadeOut()
        $('.mppp').fadeIn()
		$('.tc_navx').text('60分钟')
		$('.tc_nav').fadeIn()
		setTimeout(function(){
			$('.tc_nav').fadeOut()
		},2000)
        var a=this.params
        setTimeout(function(){
//          location.href ='/discover/discont/'+a;
            this.$router.push({path:'/discover/discont/'+a})
        },3600000)
   	},
   	//30分钟
   	minopen:function(){
		$('.qq4').text('√')
		$('.qq2').text('')
		$('.qq3').text('')
		$('.qq1').text('')
		$('.qq5').text('')
        $('.ddss').fadeOut()
        $('.mppp').fadeIn()
		$('.tc_navx').text('30分钟')
		$('.tc_nav').fadeIn()
		setTimeout(function(){
			$('.tc_nav').fadeOut()
		},2000)
        var a=this.params
        setTimeout(function(){
//          location.href = '/discover/discont/'+a;
            this.$router.push({path:'/discover/discont/'+a})
        },1800000)
   	},
   	//播放当前章节
   	nopen:function(){
   		$('.qq2').text('√')
		$('.qq1').text('')
		$('.qq3').text('')
		$('.qq4').text('')
		$('.qq5').text('')
        $('.ddss').fadeOut()
        $('.mppp').fadeIn()
		$('.tc_navx').text('当前章节')
		$('.tc_nav').fadeIn()
		setTimeout(function(){
			$('.tc_nav').fadeOut()
		},2000)
   	},
   	//不开启
   	noopen:function(){
   		$('.qq1').text('√')
		$('.qq2').text('')
		$('.qq3').text('')
		$('.qq4').text('')
		$('.qq5').text('')
        $('.ddss').fadeOut()
        $('.mppp').fadeIn()
		$('.tc_navx').text('不定时')
		$('.tc_nav').fadeIn()
		setTimeout(function(){
			$('.tc_nav').fadeOut()
		},2000)
   	},
   	//定时播放关闭
   	shut:function(){
 		$('.ddss').fadeOut()
		$('.mppp').fadeIn()      		
   	},
   	//选择全部章节
   	section:function(){
      $('.mppp').fadeOut()
      $('.zzcc').fadeIn()
   	},
   	//选择定时
   	timing:function(){
   		$('.ddss').fadeIn()
		$('.mppp').fadeOut()
   	},
   	//章节关闭
   	close:function(){
   		$('.zzcc').hide()
		$('.mppp').fadeIn()
        var html = []
        var mzzzv = $('.mzzzv')
        mzzzv.empty()
        for(var i =0 ; i<this.cbook.length;i++){
            if(i < 13){
                html[i] = '<p class="pters" id="'+this.cbook[i].bp_id+'" style="height:30px;padding: 7px 10px 7px 15px;">'+this.cbook[i].bp_title+'</p>'
            }
            
        }
        this.j=13
        var bkid=this.bookid[0]
        mzzzv.append(html)
        $('.pters').click(function(){
            var i= this.id;
//          location.href = '/discover/discont/mmm/'+[bkid,i];
            this.$router.push({path:'/discover/discont/mmm/'+[bkid,i]})
        })
   	},
   	//章节弹出返回专辑
   	back:function(){
// 		location.href = '/discover/discont/'+this.params;
   		this.$router.push({path:'/discover/discont/'+this.params})
   	},
   	//章节弹出循环播放
   	loop:function(){
        var mzzzv = $('.mzzzv')
        var html = []
        for(var i = this.j ; i<this.cbook.length;i++){
            if(i < this.j+13){
                html[i] = '<p class="pters" id="'+this.cbook[i].bp_id+'" style="height:30px;padding: 7px 10px 7px 15px;">'+this.cbook[i].bp_title+'</p>'
            } 
        }
        if(html.length == 0){
            $('.tc_navx').text('已经没有了')
            $('.tc_nav').fadeIn()
            setTimeout(function(){
                $('.tc_nav').fadeOut()
            },2000)
        }else{
            mzzzv.empty()
            mzzzv.append(html)
        }
        this.j+=13
        var bkid=this.bookid[0]
        $('.pters').click(function(){
            var i= this.id;
//          location.href = '/discover/discont/mmm/'+[bkid,i];
            this.$router.push({path:'/discover/discont/mmm/'+[bkid,i]})
        })
   	},

    //收藏
    heart:function(){
   		this.xheart++
   		var j = this.xheart % 2
   		if(j == 0){
   			$('#heartc').css('color','red');
			    $('.tc_navx').text('收藏成功！')
   		}else{
   			$('#heartc').css('color','#409eff');
   			$('.tc_navx').text('取消收藏!')
   		}
		$('.tc_nav').fadeIn()
		setTimeout(function(){
			$('.tc_nav').fadeOut()
		},2000)
		var x=this.bookid[1]
		var openid= localStorage.getItem('openid')
        this.$http.get(CURL+'/portal/All/getpartshou?bp_id='+x+'&openid='+openid,{data:{}})
    },
    //选择章节
    //     	chapter:function(bp_id){
    //          alert(bp_id)
    //     		var i= bp_id;
    //     		location.href = '/discover/discont/mmm/'+[this.bookid[0],i];
    //      	$('.zzcc').fadeOut()
    // $('.mppp').fadeIn()
    //     	},
   	//上一章
   	backward:function(){
   		var $bookid=this.bookid[1]
   		$bookid--
   		this.bookid[1]=$bookid
   		for(var i=0;i<this.listik.length;i++){
   			if(this.listik[i]==this.bookid[1]){
// 				location.href = '/discover/discont/mmm/'+[this.bookid[0],this.bookid[1]];
   				this.$router.push({path:'/discover/discont/mmm/'+[this.bookid[0],this.bookid[1]]})
   			}
   		}
   	},
   	//下一章
   	forwardc:function(){
   		// this.bookid
   		var $bookid=this.bookid[1]
   		$bookid++
   		this.bookid[1]=$bookid
   		for(var i=0;i<this.listik.length;i++){
   			if(this.listik[i]==this.bookid[1]){
// 				location.href = '/discover/discont/mmm/'+[this.bookid[0],this.bookid[1]];
   				this.$router.push({path:'/discover/discont/mmm/'+[this.bookid[0],this.bookid[1]]})
   			}
   		}
   	},
   	//修改字体
   	maax:function(){
   		var mppx=$('.ppp_2').find('p')
   		this.size+=3;
			if(this.size > 19){
				this.size = 19
			}
			mppx.css('font-size',this.size)
   	},
   	//修改字体
   	maaj:function(){
   		var mppx=$('.ppp_2').find('p')
   		this.size-=3;
			if(this.size < 12){
				this.size = 12
			}
			mppx.css('font-size',this.size)
   	},
   	//返回专辑
   	replyx:function(){
// 		location.href = '/discover/discont/'+this.params;
   		this.$router.push({path:'/discover/discont/'+this.params})
   	},
       	
   	//请求
    getAjax:function () {
    	var openid = localStorage.getItem('openid')
     	var successCallback =  (response) => {
        this.mtime = response.bookpartlist
        this.b_pic = response.booklist[0].b_pic
        if(response){
        	$("#zmint").text(response.bookpartlist[0].bp_timelength)
        	$('#xmint').text('-'+response.bookpartlist[0].bp_timelength)
        	if(response.status == 0){
            this.xheart = 1
        		$('#heartc').css('color','red');
        		this.xheart=response.status
        	}else{
            this.xheart = 1
          }
        	this.cbook=response.bookpartlist
            var html = []
            var mzzzv = $('.mzzzv')
            for(var i =0 ; i<this.cbook.length;i++){
                if(i < 13){
                    html[i] = '<p class="pters" id="'+this.cbook[i].bp_id+'" style="height:30px;padding: 7px 10px 7px 15px;">'+this.cbook[i].bp_title+'</p>'
                }
                
            }
            mzzzv.append(html)
        	var i =this.bookid[1]
            var bkid=this.bookid[0]
        	for(var j=0;j<response.bookpartlist.length;j++){
        		this.listik[j]=response.bookpartlist[j].bp_id
        		if(response.bookpartlist[j].bp_id == i){
        			this.book_gc=response.bookpartlist[j]
        		}
        	}
            $('.pters').click(function(){
                var i= this.id;
//              location.href = '/discover/discont/mmm/'+[bkid,i];
                this.$router.push({path:'/discover/discont/mmm/'+[bkid,i]})
            })
        }
        //console.log(this.book_gc.bp_upload)
      }
      var errorCallback =  (response) => {
          console.log('失败')
      }
      var c=this.$route.params.id.split(',')
      this.$http.get(CURL+'/portal/All/getplaynum?bkid='+c[0]+'&part_id='+c[1]+'&openid='+openid,{
        data:{}
      })
      this.$http.get(CURL+'/portal/All/getydzget?id='+this.$route.params.id+'&openid='+openid,{
      	data:{}
      }).then(successCallback,errorCallback);
    }
},
mounted(){
	// 字符串截取
	// var _href=location.href
	// console.log('book_id='+_href.split("="))
	this.getAjax();
},
}
</script>
<style lang="scss" scoped>

.sxcaq{
  font-size: 20px;
  font-weight: 600;
  transform:rotate(90deg);
  -ms-transform:rotate(90deg);   /* IE 9 */
  -moz-transform:rotate(90deg);  /* Firefox */
  -webkit-transform:rotate(90deg); /* Safari 和 Chrome */
  -o-transform:rotate(90deg);  /* Opera */
  color: #409eff;
}
/**/
.tc_navx{
	background-color: #00a8d9;
	border-radius: 5px;
	padding: 10px 20px 10px 20px;
}
.tc_nav{
	display: none;
	position: fixed;
	margin-left: 20%;
	text-align: center;
	width: 60%;
/*	height: 30px;*/
	color: #ffffff;
	font-size: 15px;
	bottom: 70%;
}
#axcz{
	width:0;
	height: 3px;
	background-color: #00a8d9;
}
#adzc{
	float: left;
	width: 20%;
	margin: 32px 0 20px 0; 
	color: #319c56;
	text-align: center;
}
#adzx{
	float: right;
	width: 20%;
	margin: 32px 0 20px 0; 
	color: #319c56;
	text-align: center;
}
.fast-backward,.playxc,.pausex,.fast-forward,.forward,.backward{
	float: left;
	width: 20%!important;
	text-align: center;
	color: #409eff;
}
.pausex{
	display: none;
}
/**/
#audio_a{
	width: 100%;
	height: 20px;
}
#adocx{
	width: 60%;
	margin: 40px 0 20px 0; 
	height: 3px;
	float: left;
	background-color: #eee;
}
#adoc{
	width: 100%;
	height: 50px;
	line-height: 50px;
	margin-top: 20px;
	float: left;
}
/*歌词变色*/
.Pcssgrrd{
	/*color: #319c56*/
}
/*ddss*/
.mzz_ffff{
	font-weight: 700;
	font-size: 16px;
	margin-right: 15px;
	float: right;
	background-color: inherit;
}
.mzz_pxx{
	float: left;
	width: 20%;
	padding-left: 15px;
	font-size: 15px;
	font-weight: 550;
}
.bkq0,.bkq1,.bkq2,.bkq3,.bkq4{
	padding: 8px 12px 8px 15px;
}
#q0{
	float: left;
	width: 60%;
}
#q1{
	float: right;
	width: 15px;
	height: 15px;
	border: #00a8d9 solid 1px;
	text-align: center;
	line-height: 15px;
	color: #00a8d9;
}
.ddss_x{
	float: left;
	div{
		float: left;
		p{
			float: left;
		}
	}
}
.mdxxzz{
	background-color: #ffffff;
	width: 100%;
	border-bottom: #eee solid 1px;
	padding-bottom: 13px;
}
.ddss{
	display: none;
	position: fixed;
	background-color: rgba(0,0,0,0.3);
	width: 100%;
	height: 100%;
}
/*mzzz*/
.zzcc{
	display: none;
	position: fixed;
	background-color: rgba(0,0,0,0.3);
	width: 100%;
	height: 100%;
}
.mzzzv{
	margin-top: 35px;;
}
.mzzzd{
	background-color: #ffffff;
	position: fixed;
	width: 100%;
	border-bottom: #eee solid 1px;
	padding-bottom: 13px;
}
.mzz_f{
	font-weight: 700;
	font-size: 16px;
}
.mzz_f,.mzz_h,.mzz_x{
	margin-right: 15px;
	float: right;
	background-color: inherit;
}
.mzz_p{
	float: left;
	width: 20%;
	padding-left: 15px;
	font-size: 15px;
	font-weight: 550;
}
.mzzz{
	z-index: 777;
	position: fixed;
	width: 100%;
	padding-top: 20px;
	background-color: #ffffff;
	bottom: 0;
	border-top: #eee solid 1px;
	div{
		float: left;
		width: 100%;
	}
}
/*mpp*/
#heartc{
	background-color: #ffffff;
}
.barsx{
	margin-left: 14%;
}
.cxxxx{
	color: #409eff;
}
.mppp{
	position: fixed;
	width: 100%;
	height: 2.3rem;
	padding-top: 20px;
	background-color: #ffffff;
	bottom: 0;
	border-top: #eee solid 1px;
	div{
		float: left;
		/*width: 18%;*/
		text-align: center;
	}
}
/*A*/
.maax,.maaj{
	float: right;
	color: #319c56;
	background-color: inherit;
	font-size: 17px;
	margin-right: 15px;
}
/*mp3*/
.ppp_2{
	margin-top: 30px;
}
.ppp_2{
	padding: 7px 15px 7px 15px;
	p{
		padding: 0 5px 5px 5px;
		line-height: 20px;
		font-size: 13px;
	}
	img{
		height: 100px;
		padding: 7px 0 7px 0;
	}
}
.bg_pic{
	width: 100%;
	margin-bottom: 2.3rem;
}
.ppp_1{
	width: 100%;
	position: fixed;
	padding-left: 15px;
	height: 35px;
	line-height: 35px;
	background-color: #d2f2dd;
	color: #777;
}
/*head*/
.mp3{
	margin-top: 40px;
	float: left;
	width: 100%;
	margin-bottom: 2.33rem;
}
header{
    position: fixed;
    height: .4rem;
    background:url(../../img/ss.png);
    background-size:100% 100%;
    background-repeat: no-repeat;
    float: left;
    width: 100%;
}
.set_1{
    text-align: center;
    float: left;
    width: 80%;
    line-height: .4rem;
    font-weight: 600;
    color: #FFFFFF;
    font-size: 19px;
}
.set_2{
    float: left;
    margin-left: 3%;
    margin-top: 12px;
    width: 5%;
    color: #FFFFFF;
}
.mmm{
	width: 100%;
}
.yy{
    height:5px;
}

.main-wrap{
    padding: 10px 15px;
  }
  .slider {
    display: inline-block;
    width: 165px;
    position: relative;
    top: -3px;
    margin-left: 91px;
  }

  .di {
    display: inline-block;
  }

  .download {
    color: #409EFF;
    margin-left: 15px;
  }

  .dn{
    display: none;
  }
  .el-tag{
    margin-left: 25px;
    float: left;
    height:0;
    padding:0;
    border:none;
  }
/*  .el-button--text{
    margin-left: 50%;
  }*/
  #ys{
    width:100%;
    margin-top: 43px;
  }
  #ka{
    width:18%;
  }
  .el-button--text{
    color:#409eff;
  }
  #rig{
    float:right;
    margin-top: 12px;
  }
  #righ{
    margin-top: 12px;
  }
</style>


// WEBPACK FOOTER //
// src/components/discover/mmm.vue